import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

/*
 * 加解密
 */


export function generateRandomKey() {
  return  generateSimpleKey();
  // 生成随机 AES 密钥（动态密钥更安全）
  // return CryptoJS.lib.WordArray.randomBytes(128 / 8).toString();

}
function generateSimpleKey() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < 16; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}


// AES 对称加密 加密
export function encryptAES(data, secretKey,iv) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(secretKey), {
    iv: CryptoJS.enc.Utf8.parse(iv), // 初始向量（CBC 模式必须）
    mode: CryptoJS.mode.CBC, // 加密模式
    padding: CryptoJS.pad.Pkcs7, // 填充方式
  }).toString();
}

// AES 对称加密 解密（如果需要解密后端响应）
export function decryptAES(cipherText, secretKey) {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}


// RSA 非对称 加密（使用后端提供的公钥）
export function encryptRSA(data, publicKey) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(data);
}
